<template>
  <Modal @close="$emit('close')" borderRadius="0" width="800px">
    <div class="modal__head" style="margin-bottom: 32px">
      <h3 class="modal__title">
        Предложения/Обращения
      </h3>
      <div class="close" @click.stop="closeModal">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2" />
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2" />
        </svg>
      </div>
    </div>
    <Form @request="sendReport" class="modal__content">
      <VInput label="ФИО" name="reporterName" required pattern="^[А-яЁё\s]*$" minLength="3">
          <Validation for="required">Это поле является обязательным</Validation>
          <Validation for="pattern">Это поле должно содержать только кириллицу</Validation>
          <Validation for="minLength">Это поле должно содержать больше 3 символов</Validation>
      </VInput>

      <AppRadio title="Предложение"
                name="type"
                style="margin-bottom: 10px;"
                @toggle-check="setType('proposal')"
                checked
      />
      <AppRadio title="Обращение"
                name="type"
                style="margin-bottom: 10px;"
                @toggle-check="setType('appeal')"
      />
      
      <AppInputFile
        :value="files"
        title="Прикрепите файл"
        button-text="Прикрепить"
        name="document"
        @value-changed="setFiles"
      />

      <VInput type="textarea" label="Описание предложения/обращения*" required name="comment" minLength="6" style="height:148px">
        <Validation for="required">Это поле является обязательным</Validation>
        <Validation for="minLength">Это поле должно содержать больше 6 символов</Validation>
      </VInput>

      <span class="buttons">
        <AppButton title="Отправить" type="main" :loading="loading" />
        <AppButton title="Отмена" type="alt" @click.prevent.native="closeModal" />
      </span>
    </Form>

  </Modal>
</template>

<script>
import Modal from '@/components/page/modal/base/Modal.vue'
import AppInputFile from '@/components/page/input/AppInputFile.vue'
import AppButton from '@/components/page/button/AppButton.vue'
import axios from 'axios'
import { config, url } from '@/store'
import AppRadio from '@/components/page/input/AppRadio'
import Form from '@/components/page/Form/Form.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import Validation from '@/components/page/Form/Validation.vue'

export default {
  components: {
    Modal,
    AppInputFile,
    AppButton,
    Form,
    VInput,
    Validation,
    AppRadio
  },
  data () {
    return {
      files: [],
      loading: false,
      checkedType: 'proposal'
    }
  },

  methods: {
    setType (value) {
      this.checkedType = value
    },

    closeModal () {
      this.$emit('close')
    },

    setFiles (newFiles) {
      this.files = newFiles
    },

    sendReport ({ reporterName, comment }) {
      const formData = new FormData()

      formData.append('name', reporterName)
      formData.append('description', comment)
      formData.append('type', this.checkedType)

      if (this.files.length) {
        for (let i = 0; i < this.files.length; ++i) {
          formData.append('files[]', this.files[i])
        }
      }

      this.loading = true

      axios
        .post(`${url}/appeal-report`, formData, config)
        .finally(() => {
          this.loading = false
          this.$emit('close')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.modal__content {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 28px;
  padding: 0 76px 32px 77px;
}

.buttons {
  display: flex;
  justify-content: center;
  column-gap: 10px;
}
</style>
